import { fetchOfferPageReviewSummary } from 'actions/ReviewActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect } from 'react'

type UseOfferPageReviewSummaryResult = [
  App.ReviewSummary | undefined,
  boolean,
  Error | string | undefined,
]

function useOfferPageReviewSummary(
  propertyId: string | undefined,
  propertyProvider: 'bedbank' | 'luxuryescapes',
  enabled: boolean = true,
): UseOfferPageReviewSummaryResult {
  const dispatch = useAppDispatch()

  const key = getObjectKey({ propertyId, propertyProvider })
  const summary = useAppSelector((state) => state.review.offerPageReviewSummaries[key])

  useEffect(() => {
    if (enabled && propertyId) {
      dispatch(fetchOfferPageReviewSummary(propertyId, propertyProvider))
    }
  }, [dispatch, propertyId, propertyProvider, enabled])

  if (!enabled) {
    return [undefined, false, undefined]
  }

  return [
    summary?.summary,
    summary?.fetching ?? !!propertyId,
    summary?.error,
  ]
}

export default useOfferPageReviewSummary
